export const prefix = 'hex'
export const cate = 'hex'
export const getName = name => `${prefix}-${name}`



// WEBPACK FOOTER //
// ./packages/components/constants/types.js